export const COOKIES_OPEN_SETTINGS = "COOKIES_OPEN_SETTINGS";
export const COOKIES_CLOSE_SETTINGS = "COOKIES_CLOSE_SETTINGS";
export const COOKIES_ACCEPT_ALL = "COOKIES_ACCEPT_ALL";
export const COOKIES_REJECT_NON_ESSENTIAL = "COOKIES_REJECT_NON_ESSENTIAL";
export const COOKIES_SAVE_PREFERENCES = "COOKIES_SAVE_PREFERENCES";
export const COOKIES_BOOTSTRAP = "COOKIES_BOOTSTRAP";
